import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DoHttpService } from 'src/app/core/services/do-http.service';
import { ApiUrls } from 'src/app/shared/constants/ApiUrls';
import { Testspace } from 'src/app/shared/interfaces/DrawoutTestSpace/TestSpace';
import { DatasourceAPIResponse } from 'src/app/shared/interfaces/OtherInterfaces';
import { LocationDetailsDto } from '../shared/interfaces/ITestDtos';
import { ProductTypeEnum } from 'src/app/shared/enum/ProductTypeEnum';
import { UserDetailService } from 'src/app/core/services/user-detail.service';
import { tsAdminAccess, tsAdminOnlyAccess, tsAllAccess, tstesterAccess } from 'src/app/shared/constants/RoleConstants';

@Injectable({
    providedIn: 'root'
})
export class DrawoutTestSpaceService {

    organisationId: BehaviorSubject<string>;
    testspaces: Testspace[];
    isTestspacesLoaded = false;
    // organisationsSource: BehaviorSubject<DatasourceAPIResponse>;
    selectedTestspace = new BehaviorSubject<Testspace>(null);
    assignSpecificationTestData: any = {};
    downloadInProgress = new BehaviorSubject<boolean>(false);
    isHomeScreen: BehaviorSubject<boolean>;
    selectedProjectSubtab: any;
    selectedTestSubtab: any;
    selectedIOTestSubTab: any;
    slectedItemIndexWithRoute: ItemIndexWithDashboard;
    // projectExpandedRowKeys: any[] = [];
    forAll = {
        isDoUser: this.userDetailService.getUserData().isDORole,
        productType: ProductTypeEnum.Testspace,
        accessFor: tsAllAccess
    }
    forAdmin = {
        isDoUser: this.userDetailService.getUserData().isDORole,
        productType: ProductTypeEnum.Testspace,
        accessFor: tsAdminAccess
    }
    forAdminOnly = {
        isDoUser: this.userDetailService.getUserData().isDORole,
        productType: ProductTypeEnum.Testspace,
        accessFor: tsAdminOnlyAccess
    }
    forTester = {
        isDoUser: this.userDetailService.getUserData().isDORole,
        productType: ProductTypeEnum.Testspace,
        accessFor: tstesterAccess
    }

    private currentTestspaceId: string;

    constructor(
        private request: DoHttpService,
        private userDetailService: UserDetailService) {
    }

    set testspaceId(id: string) {
        this.currentTestspaceId = id;
        this.setSelectedTestSpace();
    }

    get testspaceId() {
        return this.currentTestspaceId;
    }

    private setSelectedTestSpace() {
        this.selectedTestspace.next(this.testspaces.find(x => x.testspaceId == this.currentTestspaceId));
    }

    startService() {
        this.organisationId = new BehaviorSubject(null);
        this.isHomeScreen = new BehaviorSubject(false);
        if (localStorage.getItem("currentOrganisationId")) {
            this.organisationId.next(JSON.parse(localStorage.getItem("currentOrganisationId")));
        }
        this.isTestspacesLoaded = false;
        this.testspaces = [];
        this.selectedTestspace = new BehaviorSubject(null);
        // this.organisationsSource = new BehaviorSubject({ data: [], summary: [] })
    }

    loadTestspaces() {
        this.organisationId.subscribe(res => {
            this.request.get(ApiUrls.getTestspacesApi(this.organisationId.value)).subscribe(res => {
                this.isTestspacesLoaded = true;
                this.testspaces = res.data;
                this.setSelectedTestSpace();
            })
        });
    }

    loadOrganisations() {
        // this.request.get(ApiUrls.getAllOrganisations).subscribe(res => {
        //     this.organisationsSource.next(res);
        // });
    }

    reloadTestspaces() {
        this.organisationId.next(this.organisationId.value);
    }

    reset() {
        this.organisationId.complete();
        this.isHomeScreen.complete();
        localStorage.removeItem("currentOrganisationId");
        // this.organisationsSource.complete();
        this.testspaceId = null;
        this.isTestspacesLoaded = false;
        this.testspaces = [];
        this.selectedTestspace.complete();
    }

    enableDownloadPopup() {
        this.downloadInProgress.next(true);
    }
    disableDownloadPopup() {
        this.downloadInProgress.next(false);
    }
}

interface ItemIndexWithDashboard {
    index: number;
    dashboard: string;
}